import * as React from "react"
import { Steps } from "antd"

// fields and steps
import SendActionItemWorkflow from "components/WorkflowModalForm/views/SendActionItemWorkflow/SendActionItemWorkflow"
import FilesFormsWorkFields from "components/WorkflowModalForm/fields/FilesFormsWorkFields/FilesFormsWorkFields"
import ConfirmSendWorkflowStep from "components/WorkflowModalForm/views/ReviewApprovalWorkflow/ConfirmSendWorkflowStep/ConfirmSendWorkflowStep"

const ReviewApprovalWorkflow = ({
  form,
  stepItems,
  isResend,
  currentStep,
  setCurrentStep,
  actionItemDisabled,
  setActionItemDisabled,
  informTeam,
  setInformTeam,
  disabled,
}) => {
  const [enableTrackedChanges, setEnableTrackedChanges] = React.useState(false)

  React.useEffect(() => {
    setEnableTrackedChanges(false)
  }, [isResend])

  const renderFirstStep = () => {
    return (
      <SendActionItemWorkflow
        form={form}
        actionItemDisabled={actionItemDisabled}
        setActionItemDisabled={setActionItemDisabled}
        informTeam={informTeam}
        setInformTeam={setInformTeam}
        disabled={disabled}
        className="workflow-card-wrap"
      />
    )
  }

  const renderSecondStep = () => {
    return (
      <FilesFormsWorkFields
        form={form}
        enableTrackedChanges={enableTrackedChanges}
        setEnableTrackedChanges={setEnableTrackedChanges}
        actionItemDisabled={actionItemDisabled}
        className="workflow-card-wrap"
      />
    )
  }

  // summary
  const renderThirdStep = () => {
    return (
      <ConfirmSendWorkflowStep
        form={form}
        enableTrackedChanges={enableTrackedChanges}
        setEnableTrackedChanges={setEnableTrackedChanges}
        actionItemDisabled={actionItemDisabled}
        setActionItemDisabled={setActionItemDisabled}
        informTeam={informTeam}
        setInformTeam={setInformTeam}
        disabled={disabled}
        className="workflow-card-wrap"
      />
    )
  }

  return (
    <>
      {/* steps */}
      <Steps
        current={currentStep}
        size="small"
        items={stepItems}
        onChange={setCurrentStep}
        disabled={disabled}
        className="workflow-modal-form-steps"
      />

      <>
        {/* send email and action item */}
        {currentStep === 0 && renderFirstStep()}

        {/* forms/files */}
        {currentStep === 1 && renderSecondStep()}

        {/* confirm and send */}
        {currentStep === 2 && renderThirdStep()}
      </>
    </>
  )
}

ReviewApprovalWorkflow.propTypes = {}

export default ReviewApprovalWorkflow
